import React from 'react';
import './nav.styles.css';
import {Link} from 'react-router-dom';

export const Nav = () =>{
    return (
        <nav className="navbar navbar-expand-md navbar-light">
            <Link className="navbar-brand ml-5" to="/">TSOT</Link>
            <button className="navbar-toggler" type="button" data-toggle="collapse"
                    data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                    aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav mr-md-5 ml-auto text-center">
                    <li className="nav-item">
                        <Link className="nav-link" to="/">HOME</Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link" to="/posts">POST</Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link" to="/gallery">GALLERY</Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link" to="/about-us">ABOUT US</Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link" to="/sign-in">SIGN IN</Link>
                    </li>
                </ul>
            </div>
        </nav>
    );
}